import useAppStore from '@/store/app';
import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import useAllowedRoutes from '@/hooks/useAllowedRoutes';

const crmNavigationItems = [
  {
    title: 'Firmen und Kontakte',
    slug: 'parties',
  },
  {
    title: 'Callcenter',
    slug: 'callcenter',
    subitems: [
      { title: 'Dashboard', slug: 'callcenter' },
      { title: 'Anrufe', slug: 'callcenter/calls' },
    ],
  },
];

export default function CRMLayout() {
  const { setNavigation } = useAppStore();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const allowedCrmRoutes = useAllowedRoutes('/crm', crmNavigationItems);

  useEffect(() => {
    setNavigation({
      base: '/crm',
      items: crmNavigationItems,
    });

    if (pathname === '/crm' && allowedCrmRoutes.length > 0) {
      const firstAllowedItem = allowedCrmRoutes[0];
      let redirectToSlug;

      if (firstAllowedItem.subitems && firstAllowedItem.subitems.length > 0) {
        redirectToSlug = firstAllowedItem.subitems[0].slug;
      } else {
        redirectToSlug = firstAllowedItem.slug;
      }

      if (redirectToSlug) {
        navigate(`/crm/${redirectToSlug}`, { replace: true });
      }
    }
  }, [pathname, setNavigation, navigate, allowedCrmRoutes]);

  return (
    <Box sx={{ display: 'flex', flex: 1, height: '100%' }}>
      <Box
        sx={{
          flexGrow: 1,
          backgroundColor: 'rgba(0, 0, 0, 0.01)',
          width: '100%',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
